Array.prototype.lastItem = function () {
	return this.length - 1 > 0 ?this[this.length - 1]:undefined
}
Array.prototype.flatMap = function () {
	let flated = []
	const innerMap = array => {
		array.forEach(item=>{
			if (item instanceof Array) {
				innerMap(item)
			} else {
				flated.push(item)
			}
		})
	}
	innerMap(this)
	return flated
}